"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var models_1 = require("../models");
var csod = require("player-core");
var SearchFilterMapper = (function () {
    function SearchFilterMapper() {
    }
    SearchFilterMapper.prototype.getFilters = function (filters, isExternalCareerSiteDisplayKilometerFilterEnabled) {
        var _this = this;
        return filters.map(function (f) {
            if (f.filterType == models_1.FilterType.Distance && !isExternalCareerSiteDisplayKilometerFilterEnabled)
                f.doLocalize = false;
            return {
                title: _this.getFilterTitle(f.filterType),
                controlType: _this.getControlType(f.filterType),
                filterType: f.filterType,
                defaultKey: _this.getDefaultKey(f.filterType),
                items: f.items.map(function (i) { return _this.getFilterItem(i, f.doLocalize); })
            };
        });
    };
    SearchFilterMapper.prototype.getCustomFieldFilters = function (customFieldFilters) {
        return (customFieldFilters || []).map(function (f) {
            return {
                id: f.id,
                items: f.items.map(function (i) {
                    return {
                        key: i.key,
                        count: i.count
                    };
                })
            };
        });
    };
    SearchFilterMapper.prototype.getFilterTitle = function (filterType) {
        switch (filterType) {
            case models_1.FilterType.Country: return csod.locales.get("Country", "Country");
            case models_1.FilterType.State: return csod.locales.get("State / Province", "State / Province");
            case models_1.FilterType.City: return csod.locales.get("City", "City");
            case models_1.FilterType.Distance: return csod.locales.get("Distance", "Distance");
            case models_1.FilterType.DatePosted: return csod.locales.get("Date Posted", "Date Posted");
            default: return "";
        }
    };
    SearchFilterMapper.prototype.getControlType = function (filterType, isMultiSelect) {
        if (isMultiSelect === void 0) { isMultiSelect = false; }
        switch (filterType) {
            case models_1.FilterType.Country:
            case models_1.FilterType.State:
            case models_1.FilterType.CustomFieldCheckbox:
            case models_1.FilterType.City: return "checkbox";
            case models_1.FilterType.CustomFieldRadio:
            case models_1.FilterType.DatePosted:
            case models_1.FilterType.Distance: return "radio";
            case models_1.FilterType.CustomFieldDropdown: return isMultiSelect ? "checkbox-search" : "select";
            default: return "";
        }
    };
    SearchFilterMapper.prototype.getDefaultKey = function (filterType) {
        switch (filterType) {
            case models_1.FilterType.Distance: return "100 mi";
            case models_1.FilterType.DatePosted: return "Anytime";
            default: return "";
        }
    };
    SearchFilterMapper.prototype.getFilterItem = function (item, doLocalize) {
        return {
            key: item.key,
            count: item.count,
            text: doLocalize ? csod.locales.get(item.text, item.text) : item.text,
        };
    };
    return SearchFilterMapper;
}());
exports.SearchFilterMapper = SearchFilterMapper;



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-career-site/src/api/SearchFilterMapper.ts
// module id = 98
// module chunks = 0